import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Link } from 'newComponents'
import { getHelp } from 'utils/thirdPartyUtils'
import './styles.scss'

import logo from 'images/logos/LaunchDarkly_Icon_on_Dark_RGB.svg'

const FooterQueries = graphql`
  query {
    ...FooterFragment
  }
`

const Footer = () => {
  const data = useStaticQuery(FooterQueries)

  return (
    <footer className="section bg-dark bg-static-stars">
      <div className="container">
        <div className="footerSection">
          <div className="columns is-multiline is-mobile footer-menu">
            {data.allDataJson.nodes[0].menu.footer.map((footerTitle) => (
              <div className="column is-3-tablet is-6-mobile" key={footerTitle.name}>
                <h3 className="title is-5 is-uppercase">{footerTitle.name}</h3>
                <ul>
                  {footerTitle.children.map((item) => (
                    <li className="footerNav-item" key={item.name}>
                      <>
                        {item.url === '#get-help' ? (
                          <a href={item.url} aria-label={item.name} onClick={getHelp}>
                            {item.name}
                          </a>
                        ) : (
                          <Link to={item.url} title={item.name}>
                            {item.name}
                          </Link>
                        )}
                      </>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="footerMisc u-margintop-large columns columns--reverse is-variable is-0">
          <div className="column has-text-right-tablet has-text-centered-mobile">
            <ul className="social">
              {data.allDataJson.nodes[0].social.list.map(({ Name, Url }) => {
                const image = data.allFile.nodes.find((n) => n.name === Name.toLowerCase()).publicURL
                return (
                  <li className="social-item" key={Name}>
                    <Link to={Url} title={Name}>
                      <img src={image} alt={Name} title={Name} />
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>

          <div className="column has-text-left">
            <ul>
              <li>
                <img src={logo} className="footer-logo-copyright" alt="launchdarkly logo" />
                Copyright &copy; {new Date().getFullYear()} Catamorphic Co.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
